import React from "react";
import "./SessionDetailsToNominateTabs.css";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import UploadNomination from "../BusinessPOC/UploadNomination";
import ViewCandidateNomination from "../BusinessPOC/ViewCandidateNomination";
import MyNominations from "./MyNominations";
import { useTabContext } from "../../TabContext";
import {Link} from "react-router-dom";
import LeftArrow from '@mui/icons-material/KeyboardDoubleArrowLeft';

function TabPanel(props) {
 const { children, value, index, ...other } = props;

 return (
  <div
   role="tabpanel"
   hidden={value !== index}
   id={`simple-tabpanel-${index}`}
   aria-labelledby={`simple-tab-${index}`}
   {...other}
  >
   {value === index && (
    <Box sx={{ p: 2 }}>
     <Typography>{children}</Typography>
    </Box>
   )}
  </div>
 );
}

TabPanel.propTypes = {
 children: PropTypes.node,
 index: PropTypes.number.isRequired,
 value: PropTypes.number.isRequired,
};

function a11yProps(index) {
 return {
  id: `simple-tab-${index}`,
  "aria-controls": `simple-tabpanel-${index}`,
 };
}

const SessionDetailsToNominateTabs = () => {
 const {homeActiveTab, setHomeActiveTab} = useTabContext();
 const {isActiveLink, setIsActiveLink} = useTabContext()

 const handleChange = (event, newValue) => {
  setHomeActiveTab(newValue);
 };
 const backToHomeHandler = () => {
    setIsActiveLink(false)
 }
 return (
  <>
   <div className="banner training-banner-box">
    <img
     src={process.env.PUBLIC_URL + "/images/Home/training-banner.png"}
     alt="banner"
     className="home-banner"
    />
    <h1 className="banner-content">Training Requestor View</h1>
   </div>
   <div className="main-container">
    <Box className="boxStyles">
    <div className= "back-to-home" title= "Back to Home">
    <Link to = "/" onClick ={backToHomeHandler} className= "bth-link" title= "Back to Home">Back to Home <LeftArrow /></Link>
    </div>
     <Box sx={{ borderColor: "divider" }} className="tabMenuWrap">
      <Tabs
       value={homeActiveTab}
       onChange={handleChange}
       aria-label="basic tabs example"
       centered
      >
       <Tab label="Upload Nominations" key="tab0"{...a11yProps(0)} className="tabStyles" />
       <Tab label="My Nominations" key="tab1"{...a11yProps(1)} className="tabStyles" />
      </Tabs>
     </Box>
     <TabPanel className="tabPanelWrap" value={homeActiveTab} index={0}>
      <UploadNomination />
     </TabPanel>
     <TabPanel className="tabPanelWrap" value={homeActiveTab} index={1}>
      {/* <ViewCandidateNomination /> */}
      <MyNominations />
     </TabPanel>
    </Box>
   </div>
  </>
 );
};

export default SessionDetailsToNominateTabs;
